import type { FunctionDef } from '@thinkalpha/language-services';
import type { FieldDescriptor } from '@thinkalpha/table-client';
import { CategoryForFieldType } from '@thinkalpha/ui-core/util/fields';
import { v4 as uuidv4 } from 'uuid';

export function fieldDescriptorToFunctionDef(desc: FieldDescriptor): FunctionDef {
    return {
        id: uuidv4(),
        symbol: desc.name,
        overloads: [
            {
                returnType: CategoryForFieldType.get(desc.type)!,
                params: [],
            },
        ],
    };
}
